import React, { useState, useEffect, useMemo, useCallback } from 'react';
import StreamsList from './StreamsList';
import StreamModal from './StreamModal';
import { fetchStreamData } from '../utils/dataMapper';
import { calculateAllStreamStatuses } from '../utils/statusCalculator';
import '../styles/ArchiveContainer.css';

const ArchiveContainer = () => {
  // API URL (本番環境を判定)
  const isProduction = window.location.hostname === 'schedule.stpr.com';
  const API_URL = isProduction
    ? 'https://schedule-share-json.s3.ap-northeast-1.amazonaws.com/schedule/schedule_v2.json'
    : 'https://dev-schedule-share-json.s3.ap-northeast-1.amazonaws.com/schedule/schedule_v2.json';

  // 状態管理
  const [rawStreams, setRawStreams] = useState([]); // APIから取得した生データ
  const [loading, setLoading] = useState(true);
  const [hasAnimated, setHasAnimated] = useState(false); // アニメーション実行済みフラグ
  const [selectedStream, setSelectedStream] = useState(null); // 選択されたストリーム
  const [isModalOpen, setIsModalOpen] = useState(false); // モーダルの開閉状態
  const viewMode = 'grid'; // カードタイプ表示に固定

  // データ取得関数（初回のみ）
  const loadStreamData = useCallback(async () => {
    setLoading(true);
    try {
      const result = await fetchStreamData(API_URL);
      setRawStreams(result.streams); // 生データを保存
    } catch (error) {
      console.error('アーカイブデータの取得に失敗しました:', error);
      setRawStreams([]);
    } finally {
      setLoading(false);
    }
  }, [API_URL]);

  // 初回データ取得のみ
  useEffect(() => {
    loadStreamData(); // 初回実行のみ
  }, [loadStreamData]);

  // 生データをそのまま使用（ステータス計算を削除）
  const streams = useMemo(() => {
    // アーカイブデータのみをフィルタリング
    return rawStreams.filter(stream => stream.isArchive);
  }, [rawStreams]);

  // お気に入り切り替え関数
  const toggleFavorite = (streamId) => {
    // 生データを更新
    const updatedRawStreams = rawStreams.map(stream => 
      stream.id === streamId 
        ? { ...stream, isFavorite: !stream.isFavorite } 
        : stream
    );
    setRawStreams(updatedRawStreams);
  };

  // ストリームカードクリック時の処理
  const handleStreamClick = (stream) => {
    setSelectedStream(stream);
    setIsModalOpen(true);
  };

  // モーダルを閉じる処理
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedStream(null);
  };

  // 初回ロードアニメーションの制御
  useEffect(() => {
    if (!loading && streams.length > 0 && !hasAnimated) {
      setHasAnimated(true);
    }
  }, [loading, streams.length, hasAnimated]);

  return (
    <section className="archive-container">
      <div className="archive-header">
        <h2>アーカイブ</h2>
      </div>

      {loading ? (
        <div className="loading-message">
          <p>アーカイブデータを読み込み中...</p>
        </div>
      ) : (
        <StreamsList 
          streams={streams} 
          toggleFavorite={toggleFavorite} 
          viewMode={viewMode}
          onStreamClick={handleStreamClick}
          slideDirection="" // アニメーションなし
          isFirstLoad={false}
          selectedDate={new Date()}
          isArchiveMode={true}
        />
      )}
      
      {/* ストリームモーダル */}
      <StreamModal 
        stream={selectedStream}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </section>
  );
};

export default ArchiveContainer;
